import API from "../axiosConfig";

export const getAllTariffSubscriptions = async () => {
  try {
    const response = await API.get("/tariff-subscriptions");
    return response.data.data;
  } catch (error) {
    console.error("Error fetching all tariff subscriptions:", error);
    throw error;
  }
};

// export const getTariffSubscriptions = async (periodId) => {
//   try {
//     const response = await API.get(`/tariff-periods/${periodId}/tariffs`);
//     return response.data.data;
//   } catch (error) {
//     console.error("Error fetching tariff subscriptions:", error);
//     throw error;
//   }
// };

export const updateTariffSubscriptions = async (periodId, tariffs) => {
  try {
    const response = await API.post(`/tariff-periods/${periodId}/tariffs`, {
      tariffs,
    });
    return response.data;
  } catch (error) {
    console.error("Error updating tariff subscriptions:", error);
    throw error;
  }
};

// export const getCurrentTariffs = async () => {
//   try {
//     const response = await API.get("/tariffs/current");
//     return response.data.data;
//   } catch (error) {
//     console.error("Error fetching current tariffs:", error);
//     throw error;
//   }
// };

// export const getCurrentPrice = async (subscriptionTypeId) => {
//   try {
//     const response = await API.get(
//       `/subscription-types/${subscriptionTypeId}/current-price`
//     );
//     return response.data.price;
//   } catch (error) {
//     console.error("Error fetching current price:", error);
//     throw error;
//   }
// };
